import tw from 'twin.macro'

type SpinnerProps = {
  size?: string
  color?: 'white' | 'primaryBlue'
  borderWidth?: string
}
function Spinner({ size = '2.5rem', color = 'primaryBlue', borderWidth = '4px' }: SpinnerProps) {
  const style = { borderColor: 'white', borderWidth, height: size, width: size }
  return (
    <div tw="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      <div
        className="spinner"
        css={[
          tw`animate-spin rounded-full border-4 !border-b-transparent`,
          color === 'white' && tw`border-white`,
          color === 'primaryBlue' && tw`border-primaryBlue`,
        ]}
        {...{ style }}
      />
    </div>
  )
}

export default Spinner
